/** @format */

import { useCallback, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setDashboard } from "redux/actions/dashboardAction";
import { getDashboardAll } from "services/v2/notificationservice";

const CACHE_TTL = 30 * 60 * 1000;

export const useDashboard = (auth: any) => {
  const dispatch = useDispatch();

  const { header1, header2, header3, akb, snp, cacheTime } = useSelector(
    (state: any) => ({
      header1: state.dashboard?.header1 || {},
      header2: state.dashboard?.header2 || [],
      header3: state.dashboard?.header3 || [],
      akb: state.dashboard?.akb || [],
      snp: state.dashboard?.snp || [],
      cacheTime: state.dashboard?.cacheTime || {},
    }),
    shallowEqual,
  );

  const [loading, setLoading] = useState(false);
  const [dataDetail, setDataDetail] = useState([]);
  const fetchData = useCallback(
    async (force: boolean = false, filter: any = {}) => {
      if (!auth?.isTahun) return;

      const now = Date.now();
      const lastFetch = cacheTime?.dashboard;

      /** gunakan cache jika masih valid */
      if (
        !force &&
        Object.keys(header1).length > 0 &&
        header2.length &&
        header3.length &&
        akb.length &&
        snp.length &&
        lastFetch &&
        now - lastFetch < CACHE_TTL
      ) {
        return;
      }

      setLoading(true);

      try {
        let params = {
          tahun: auth?.isTahun,
          ...filter,
        };

        if (auth?.group_role !== "pusat") {
          params["kodeProvinsi"] = auth?.kode_provinsi;
        }

        if (!["pusat", "provinsi"].includes(auth?.group_role)) {
          params["kodeKabKota"] = auth?.kode_kabkota;
        }

        if (auth?.group_role === "madrasah") {
          params["nsm"] = auth?.madrasah?.nsm;
        }

        const [dashboard1, dashboard2, dashboard3, dashboardAkb, dashboardSnp] =
          await Promise.all([
            getDashboardAll("dashboard/header-1", params),
            getDashboardAll("dashboard/header-2", params),
            getDashboardAll("dashboard/header-3", params),
            getDashboardAll("dashboard/akb", params),
            getDashboardAll("dashboard/snp", params),
          ]);
        /** filter provinsi jika bukan admin pusat */
        // if (auth?.kode_role !== "admin_pusat_bos") {
        //   result = result.filter(
        //     (item: any) => item.kodeProvinsi === auth?.kode_provinsi,
        //   );
        // }

        dispatch(
          setDashboard({
            header1: dashboard1 || {},
            header2: dashboard2 || [],
            header3: dashboard3 || [],
            akb: dashboardAkb || [],
            snp: dashboardSnp || [],
            cacheTime: {
              ...cacheTime,
              dashboard: Date.now(),
            },
          }),
        );
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      auth?.isTahun,
      auth?.kode_role,
      auth?.kode_provinsi,
      cacheTime?.dashboard,
      dispatch,
    ],
  );

  const getDataDetail = useCallback(
    async (link: string, payload: any) => {
      setLoading(true);

      try {
        let params: any = {
          tahun: auth?.isTahun,
          ...payload,
        };

        if (auth?.group_role !== "pusat") {
          params.kodeProvinsi = auth?.kode_provinsi;
        }

        if (!["pusat", "provinsi"].includes(auth?.group_role)) {
          params.kodeKabKota = auth?.kode_kabkota;
        }

        const result = await getDashboardAll(`dashboard/${link}`, params);

        setDataDetail(result || []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
    [auth?.isTahun, auth?.group_role, auth?.kode_provinsi, auth?.kode_kabkota],
  );
  /**
   * fetch ketika tahun berubah
   */

  return {
    loading,
    header1,
    header2,
    header3,
    akb,
    snp,
    dataDetail,
    getDataDetail,
    fetchData,
    cacheTime,
  };
};
